export default __webpack_public_path__ + "static/media/search-down.befa0720.svg";